import { useState, ReactElement } from 'react'
import { T } from 'react-translator-component'
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { colors } from '../../common/colors';

interface Props{
  onChange: (date: any) => void
  inputedDate?: any
  minDate?: any
  maxDate?: any
  errorMessage?: string
  disabled?: boolean
}

function DateSelectDialog ({disabled, onChange, inputedDate, minDate, maxDate, errorMessage}: Props): ReactElement {
  const [date, setDate] = useState<Dayjs | null>(
    dayjs(new Date())
  )

  const handleChange = (date: any) => {
    setDate(date?.locale("ja") ?? null);
    onChange(date?.locale("ja"));
  }

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="ja"
      localeText={{
        cancelButtonLabel: `${T("mng_cancel")}`, // Change "CANCEL" to "キャンセル"
        okButtonLabel: `${T("mng_decide")}`, // Optional: Change "OK" to "決定" (Confirm)
      }}
    >
      <DemoContainer components={["DatePicker", "DatePicker"]}>
        <DatePicker
          disabled={disabled}
          value={inputedDate || date}
          onChange={(newValue) => handleChange(newValue)}
          minDate={minDate}
          maxDate={maxDate}
          format="YYYY年M月D日 (dd)" // Format to "2025年1月27日 (月)"
          slotProps={{
            toolbar: {
              toolbarTitle: `${T("mng_select_date")}`, // Change toolbar title to "日付の選択"
              toolbarFormat: "M月D日 (dd)",
            } as any,
            textField: {
              error: errorMessage !== undefined && errorMessage !== '',
              helperText: errorMessage
            },
            dialog: {
              disableRestoreFocus: true,
            }
          }}
          sx={{ backgroundColor: colors.farm_white }}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}

export default DateSelectDialog